import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './data-table.css';

export class SimpleDataTable extends Component {
  static propTypes = {
    configTable: PropTypes.object,
    items: PropTypes.array,
    columns: PropTypes.array,
    onTableBinding: PropTypes.func
  }
  constructor(props) {
    super(props);
  }

  onSort(e, fieldName) {

    $('.cls-sort-icon').attr('class', 'glyphicon glyphicon-sort cls-sort-icon');

    var elm = $('#' + fieldName).parent();

    let order = $(elm).attr('data-order');

    if (order === 'ascending') {
      $('#' + fieldName).attr('class', 'glyphicon glyphicon-triangle-top cls-sort-icon');
      $(elm).attr('data-order', 'descending');
    } else {
      $('#' + fieldName).attr('class', 'glyphicon glyphicon-triangle-bottom cls-sort-icon');
      $(elm).attr('data-order', 'ascending');
    }

    var config = {
      sort: { field: fieldName, order: order },
      page: { skip: 1, take: this.props.configTable.take }
    };

    this.props.onTableBinding(config);

  }

  renderHeader(item, i) {
    let className = (item.className ? item.className : '');

    if (item.sort) {

      if (item.defaultSortOrder) {
        var sortIcon = item.defaultSortOrder === 'ascending' ? 'glyphicon glyphicon-triangle-top' : 'glyphicon glyphicon-triangle-bottom';

        return <th data-order={item.defaultSortOrder} onClick={(e) => {
          this.onSort(e, item.name);
        }} className={className + ' cls-sort'} key={i}>{item.title}
          <span id={item.name} className={sortIcon + ' cls-sort-icon'} />
        </th>;
      }

      return <th data-order='ascending' key={i} onClick={(e) => {
        this.onSort(e, item.name);
      }} className={className + ' cls-sort'}>{item.title}
        <span id={item.name} className='glyphicon glyphicon-sort cls-sort-icon' />
      </th>;
    }

    return <th className={className} key={i}>{item.title}</th>;
  }

  renderBody() {
    if (this.props.items.length > 0) {
      return this.props.items.map((item, i) => this.renderRow(item, i));
    }

    return <tr className='no-items'><td>No Items</td></tr>;
  }

  renderRow(item, key) {
    return <tr key={key}>{this.props.columns.map((obj, i) => {
      if (obj.name === 'action') {
        return <td className={obj.className} style={obj.style} key={i}>
          <a className={'cls-action ' + obj.icon} onClick={(e) => { obj.event(e, item); }} />
        </td>;
      } else {
        if (obj.customRender) {
          return <td className={obj.className} key={i}>{obj.customRender(item)}</td>;
        }
        return <td className={obj.className} style={obj.style} key={i}>{item[obj.name]}</td>;
      }
    })}</tr>;
  }

  render() {
    return <div className='cls-data-table'>
      <table className='table table-hover'>
        <thead>
          <tr className='cls-row'>
            {this.props.columns.map((item, i) => this.renderHeader(item, i))}
          </tr>
        </thead>
        <tbody className='cls-tbody-simple-table'>
          {this.renderBody()}
        </tbody>
      </table>
    </div>;
  }
}




// WEBPACK FOOTER //
// ./src/components/data-table/simple-data-table.js